export default "__VITE_ASSET__1af43575__"